<template>
  <div
    class="mobile-menu tw-transition-all tw-ease-in-out tw-duration-500 tw-pb-32 tw-z-30"
    :class="{ '!tw-top-0': open }"
  >
    <div class="wrapper">
      <h3 class="heading">Quick Links</h3>
      <div class="quick-links" v-html="quickLinks"></div>
      <div class="navigation" v-html="mainMenu"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    quickLinks: { type: String, default: "" },
    mainMenu: { type: String, default: "" },
    open: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss">
.mobile-menu {
  position: absolute;
  top: -100vh;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  padding-top: 115px;
  background-color: white;
  font-weight: bold;

  ul {
    li {
      a {
        display: block;
        height: 3.45em;
        line-height: 1.45em;
        padding: 1em 15px;
        font-weight: normal;
      }
    }
  }

  .wrapper {
    max-width: 500px;
    margin: 0 auto;
  }
  .heading {
    padding: 0 15px;
    margin-bottom: 0.5em;
    text-align: left;
    color: #000;
  }
  .quick-links {
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      li {
        &:not(:last-of-type) {
          border-bottom: 1px solid white;
        }
        a {
          color: white;
          background-color: #1e7dae;
          &:hover,
          &:focus {
            color: #1e7dae;
            background-color: white;
          }
        }
      }
    }
  }
  .navigation {
    margin-top: 2em;
    > ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      > li {
        border-bottom: 2px solid white;
        a {
          padding: 1em;
          color: white;
          background-color: #d8390e;
          &:hover,
          &:focus {
            color: #f05b3a;
            background-color: white;
          }
        }
        ul {
          list-style-type: none;
          margin: 0;
          padding: 0;
          li {
            a {
              height: 2.45em;
              padding: 0.5em 1em 0.5em 3em;
            }
          }
          ul {
            li {
              a {
                padding: 0.5em 1em 0.5em 4.5em;
              }
            }
          }
        }
      }
    }
  }
}
</style>
